/**
 * Normalise pasted blog HTML for in-app rendering.
 * - Extracts <style> blocks (e.g. from <head>) so custom diagram/layout CSS is preserved
 * - Strips document wrappers (<!DOCTYPE>, <html>, <head>, <body>) when present
 */
export const prepareBlogHtml = (raw) => {
  let html = String(raw).trim();
  if (!html) return '';

  const styleBlocks = [];
  const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
  let match;
  while ((match = styleRegex.exec(html)) !== null) {
    styleBlocks.push(match[1].trim());
  }

  const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  if (bodyMatch?.[1]) {
    html = bodyMatch[1].trim();
  } else if (/<!DOCTYPE|<\/?html|<\/?head/i.test(html)) {
    html = html
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>/gi, '')
      .replace(/<\/html>/gi, '')
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
      .replace(/<body[^>]*>/gi, '')
      .replace(/<\/body>/gi, '')
      .trim();
  }

  html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '').trim();

  if (styleBlocks.length > 0) {
    html = `<style>${styleBlocks.join('\n')}</style>${html}`;
  }

  return html;
};
